module.exports = __webpack_public_path__ + "static/media/newLogoold.70915793.svg";